import makeConcurrent from 'make-concurrent';
import createInMemoryAtom from '../factories/memory.js';
const optimisticNotifier = (atom) => {
    const memoryAtom = createInMemoryAtom();
    const set = makeConcurrent(async (newValue, fromRemote) => {
        let previous;
        await memoryAtom.set((previousValue) => {
            previous = previousValue;
            return newValue;
        });
        if (fromRemote)
            return;
        atom
            .set(newValue)
            .catch(() => memoryAtom.set((value) => (value === newValue ? previous : value)));
    });
    let unsubscribeSource;
    let subscribers = 0;
    const maybeUnsubscribeSource = () => {
        subscribers -= 1;
        if (subscribers > 0)
            return;
        unsubscribeSource();
        unsubscribeSource = undefined;
    };
    const observe = (callback) => {
        if (subscribers === 0) {
            unsubscribeSource = atom.observe((value) => set(value, true));
        }
        subscribers += 1;
        const unsubscribe = memoryAtom.observe(callback);
        return () => {
            unsubscribe();
            maybeUnsubscribeSource();
        };
    };
    const get = async () => {
        if (subscribers === 0) {
            return atom.get();
        }
        return memoryAtom.get();
    };
    const _set = (value) => set(value, false);
    return {
        ...memoryAtom,
        set: _set,
        get,
        observe,
    };
};
export default optimisticNotifier;
